import classes from '@/components/Shares/Button.module.css';
import { MODAL, useModalAction } from '@/providers/ModalActionProvider';
import { gunterzBold } from '@/theme/fonts';
import { useLingui } from '@lingui/react';
import { ActionIcon, Group, Modal, SimpleGrid, Stack, Text } from '@mantine/core';
import { IconLink } from '@tabler/icons-react';
import { Icons } from '../Shares/Icons';
import modalStyle from './ShareModal.module.css';
export type ShareButton = {
  icons: React.ReactNode;
  btnName: string;
};
const links: ShareButton[] = [{
  icons: <IconLink size={24} />,
  btnName: 'Copy link'
}, {
  icons: <Icons className="icon-pr-flat-x" fontSize={24} />,
  btnName: 'X'
}, {
  icons: <Icons className="icon-pr-flat-instagram" fontSize={24} />,
  btnName: 'instagram'
}, {
  icons: <Icons className="icon-pr-flat-facebook" fontSize={24} />,
  btnName: 'facebook'
}, {
  icons: <Icons className="icon-pr-flat-telegram" fontSize={24} />,
  btnName: 'telegram'
}, {
  icons: <Icons className="icon-pr-flat-steam" fontSize={24} />,
  btnName: 'steam'
}, {
  icons: <Icons className="icon-pr-flat-discord" fontSize={24} />,
  btnName: 'discord'
}, {
  icons: <Icons className="icon-pr-flat-twitch" fontSize={24} />,
  btnName: 'twitch'
}];
export const ShareModal: React.FC = () => {
  const {
    openModal,
    setOpenModal
  } = useModalAction();
  const {
    i18n
  } = useLingui();
  return <Modal opened={openModal === MODAL.SHARE} onClose={() => setOpenModal(null)} title={<Text fz="lg" ta="center" w="100%" className={gunterzBold.className}>
          {i18n._('Share this game')}
        </Text>} centered classNames={modalStyle}>
      <Group justify="center">
        <SimpleGrid w={348} cols={4} pb={32}>
          {links.map(item => <Stack key={item.btnName} align="center" gap={4}>
              <ActionIcon size="xl" classNames={{
            root: classes.btnIcon
          }}>
                {item.icons}
              </ActionIcon>
              <Text fz={10} tt="uppercase">
                {item.btnName}
              </Text>
            </Stack>)}
        </SimpleGrid>
      </Group>
    </Modal>;
};